module.exports = __webpack_public_path__ + "static/media/message_ping.5cab6bc.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/sounds/message_ping.mp3
// module id = 393
// module chunks = 1